import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { UtilityService } from '../../../core/services/utility.service';
import { TTViewNavigator, TT_VIEW_NAVIGATOR, useNavigatorFor } from '../../../modal/state-modal/state-modal.component';
import { CalculationGet, GetSpecialCustProdCalcParams, PriceItem, ProductItem, SpecialCustProdCalcService } from '../../../services/special-cust-prod-calc.service';

@Component({
    selector: 'tt-special-cust-prod-calc',
    templateUrl: './special-cust-prod-calc.component.html',
    styleUrls: ['./special-cust-prod-calc.component.css'],
    standalone: false,
})
export class SpecialCustProdCalcComponent implements OnInit {
    @Input()
    public params?: GetSpecialCustProdCalcParams;
    
    public productId: string = '';

    public selectListProducts: ProductItem[] = [];

    public calculation?: CalculationGet;

    public inputListPrices: PriceItem[] = [];

    constructor(
        private utility: UtilityService,
        private specialCustProdCalc: SpecialCustProdCalcService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private async loadProducts() {
        this.selectListProducts = await this.specialCustProdCalc.listProducts();

        this.selectListProducts.forEach((item) => {
            if (item?.prod_id && item.prod_id > '') {
                this.productId = item.prod_id;
            }
        });
    }

    private async retrieveCalculation() {
        if (!this.params) return;

        if (!!this.params.cust_no && !!this.productId) {
            this.calculation = await this.specialCustProdCalc.getCalculation({
                cust_no: this.params.cust_no,
                prod_id: this.productId
            });
        }
    }

    private async retrievePrices() {
        if (!this.params) return;
        if (!this.calculation) return;

        if (!!this.params.cust_no && !!this.productId && !!this.calculation.discount && !!this.calculation.sold_freight) {
            this.inputListPrices = await this.specialCustProdCalc.listPrices({
                cust_no: this.params.cust_no,
                prod_id: this.productId,
                price: this.utility.parseNumber(this.calculation.price),
                discount: this.utility.parseNumber(this.calculation.discount),
                bonus: this.utility.parseNumber(this.calculation.bonus),
                sold_freight: this.utility.parseNumber(this.calculation.sold_freight),
                weight: this.utility.parseNumber(this.calculation.weight),
                postplace_id: this.calculation.postplace_id
            });
        }
    }

    public async onProductChanged(_: string) {
        await this.retrieveCalculation();
        this.retrievePrices();
    }

    public onCalculationBlur(id: string) {
        if (!this.calculation) return;

        switch (id) {
            case 'discount':
            case 'sold_freight':
            case 'postplace_id':
                this.retrievePrices();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadProducts();

        Promise.all([
            this.retrieveCalculation()
        ]).then(() => {
            this.retrievePrices();
            Promise.resolve();
        });
    }

    ngOnInit() {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;

            this.init();
        }
    }
}
